import Card from '@/models/Card/card';

export default class PaginatedCardCollection {
  constructor({
    cards = [],
    cursor = null,
  } = {}) {
    this.cards = Card.createCollectionFromObject(cards);
    this.cursor = cursor;
  }

  aggregate(paginatedCardCollection) {
    this.cards = this.cards.concat(paginatedCardCollection.cards);
    this.cursor = paginatedCardCollection.cursor;
  }

  static createFromObject(data) {
    return new PaginatedCardCollection(data);
  }

  static createCollectionFromObject(data) {
    return data.map(
      (cardData) => Card.createFromObject(cardData),
    );
  }
}
